<!-- start page title -->
<section class="sub-page-heading-section wow animate__fadeIn bg-light-gray page-title-small">
    <div class="container">
        <div class="row align-items-center justify-content-center">
            <div class="col-12 col-xl-8 col-lg-6">
                <h1 class="alt-font text-extra-dark-gray font-weight-500 no-margin-bottom text-center text-lg-start">Shopping cart</h1>
            </div>
            <div class="col-12 col-xl-4 col-lg-6 breadcrumb justify-content-center justify-content-lg-end text-small alt-font md-margin-10px-top">
                <ul class="xs-text-center">
                    <li><a [routerLink]="['/']">Home</a></li>
                    <li>Shopping cart</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- end page title -->
<!-- start section -->
<section class="wow animate__fadeIn">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 padding-70px-right lg-padding-30px-right md-padding-15px-right">
                <div class="row align-items-center">
                    <div class="col-12">
                        <table class="table cart-products margin-60px-bottom md-margin-40px-bottom sm-no-margin-bottom">
                            <thead>
                                <tr>
                                    <th scope="col" class="alt-font"></th>
                                    <th scope="col" class="alt-font"></th>
                                    <th scope="col" class="alt-font">Product</th>
                                    <th scope="col" class="alt-font">Price</th>
                                    <th scope="col" class="alt-font">Quantity</th>
                                    <th scope="col" class="alt-font">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let product of cartService.cart.orderList; let i = index"> 
                                    <td class="product-remove">
                                        <button class="btn btn-danger text-large" (click)="cartService.cart.removeProductById(product.id)">&times;</button>
                                    </td>
                                    <td class="product-thumbnail">
                                        <img class="cart-product-image" [src]="environment.apiUrl + product.picture" alt="{{product.name}}"/>
                                    </td>
                                    <td class="product-name">
                                        <a >{{product.name}}</a>
                                        <!-- <span class="variation"> Size: L</span> -->
                                    </td>
                                    <td class="product-price" data-title="Price">${{product.unit_price}}</td>
                                    <td class="product-quantity" data-title="Quantity">
                                        <div class="quantity">
                                            <label class="screen-reader-text">Quantity</label>
                                            <input type="button" value="-" class="qty-minus qty-btn"  min="0" (click)="cartService.cart.subOne(product)">
                                            <input class="input-text qty-text" type="number" name="quantity" [(ngModel)]="product.qty" disabled>
                                            <input type="button" value="+" class="qty-plus qty-btn"  min="1000" (click)="cartService.cart.addOne(product)">
                                        </div>
                                    </td> 
                                    <td class="product-subtotal" data-title="Total">${{product.total()}}</td> 
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-md-6 md-margin-50px-bottom sm-margin-20px-bottom"> 
                        <!-- <div class="coupon-code-panel">
                            <input type="text" placeholder="Coupon code">
                            <a href="#" class="btn apply-coupon-btn text-uppercase">Apply</a>
                        </div> -->
                    </div>
                    <div class="col-md-6 text-center text-md-end md-margin-50px-bottom btn-dual">
                        <a role="button" class="btn btn-fancy btn-small btn-transparent-light-gray" (click)="cartService.cart.empty()">Empty cart</a>
                        <!-- <a href="#" class="btn btn-fancy btn-small btn-transparent-light-gray me-0">Update cart</a> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="bg-light-gray padding-50px-all lg-padding-30px-tb lg-padding-20px-lr md-padding-20px-tb">
                    <span class="alt-font text-large text-extra-dark-gray margin-15px-bottom d-inline-block font-weight-500">Order Details</span>
                    <table class="w-100 total-price-table">
                        <tbody>
                            <tr>
                                <th class="w-50 font-weight-500 text-extra-dark-gray">Subtotal</th>
                                <td class="text-extra-dark-gray">${{cartService.cart.total}}</td>
                            </tr>
                           
                            <tr class="total-amount">
                                <th class="font-weight-500 text-extra-dark-gray">Total</th>
                                <td data-title="Total">
                                    <h6 class="d-block font-weight-500 mb-0 text-extra-dark-gray">${{cartService.cart.total}}</h6>
                                    <!-- <span class="text-small text-extra-medium-gray">(Includes ${{}} GST)</span> -->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="!isLoggedIn$">
                        <a [routerLink]="['/checkout']" class="btn btn-dark-gray btn-large d-block btn-fancy margin-15px-top">Proceed to checkout</a>
                    </div>
                    <button *ngIf="loading" class="btn btn-dark-gray btn-large d-block btn-fancy margin-15px-top" >Placing...</button>
                    <button *ngIf="!loading" class="btn btn-dark-gray btn-large d-block btn-fancy margin-15px-top" (click)="placeOrderOnAccount()">Place Order</button>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end section -->